import { NavLink } from 'react-router-dom'
import { NAV } from '../nav.js'
import { useAccess } from '../lib/access.jsx'
import {platformAvailable} from '../lib/platformTools.js'
import {useToolAccess} from '../lib/toolAccess.jsx'
import styles from './Sidebar.module.css'

/**
 * Persistent left navigation, headed by the canonical Southern Recognition
 * mark. The asset is OWNED and served from this repo (`public/brand/`) — never
 * hot-linked from an external host.
 */
export default function Sidebar({ open, onClose, mobile=false, panelRef }) {
  // Role-aware: a module the actor's role cannot view is not offered.
  const { visibleNav, roleMeta, role } = useAccess()
  const tools=useToolAccess()
  const items = visibleNav(NAV).filter(item=>platformAvailable(tools,item.to)&&(item.to!=='/artwork-studio'||tools?.available('artwork')))
  const primaryPaths = ['/', '/command-center', '/artwork-studio', '/production', '/performance']
  const primaryLabels = {'/':'Today','/command-center':'Opportunities','/artwork-studio':'Artwork','/production':'Orders','/performance':'Performance'}
  const primary = primaryPaths.map(path => items.find(item => item.to === path)).filter(Boolean)
  const secondary = items.filter(item => !primaryPaths.includes(item.to))

  return (
    <aside id="platform-navigation" ref={panelRef} className={styles.sidebar} data-open={open} aria-hidden={mobile&&!open?true:undefined} inert={mobile&&!open?'':undefined} role={mobile&&open?'dialog':undefined} aria-modal={mobile&&open?true:undefined} aria-label={mobile&&open?'Navigation':undefined}>
      <div className={styles.brand}>
        <div className={styles.mark}>
          <img
            className={styles.seal}
            src="/brand/sr-monogram.png"
            alt=""
            width="34"
            height="34"
            aria-hidden="true"
          />
          <div className={styles.wordmark}>
            <b className="display">Southern</b>
            <span>Recognition</span>
          </div>
        </div>
        <button
          className={styles.close}
          onClick={onClose}
          aria-label="Close navigation"
        >
          ✕
        </button>
      </div>

      <nav className={styles.nav} aria-label="Primary">
        {tools?.data?.canManage&&<NavLink className={styles.item} to="/tool-access">Tool access</NavLink>}
        <div className={`${styles.section} eyebrow`}>Platform</div>
        {primary.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            className={({ isActive }) =>
              `${styles.item} ${isActive ? styles.itemActive : ''}`
            }
          >
            <Icon />
            <span className={styles.label}>{primaryLabels[to] || label}</span>

          </NavLink>
        ))}
        <details className={styles.more}>
          <summary>Research & more tools</summary>
          {secondary.map(({to,label,icon:Icon,end}) => (
            <NavLink key={to} to={to} end={end} className={({isActive})=>`${styles.item} ${isActive?styles.itemActive:''}`}>
              <Icon/><span className={styles.label}>{label}</span>
            </NavLink>
          ))}
        </details>
      </nav>

      <div className={styles.lane} data-role={role} title={roleMeta?.blurb}>
        <span className="eyebrow">{roleMeta?.label}</span>
        <span className={styles.laneScope}>{roleMeta?.lane}</span>
      </div>

      <div className={styles.foot}>
        <img
          className={styles.footLockup}
          src="/brand/sr-lockup.png"
          alt="Southern Recognition Inc."
          width="120"
          height="83"
        />
        <span className="eyebrow">Unified Platform</span>
      </div>
    </aside>
  )
}
